export default __webpack_public_path__ + "static/SR India - FSSAI - Manufacturing & Relabeling license - Certificate-31a087bbb1ea0e4de11d69080c7237d3.pdf";